import AccountCreation from "@/components/signup/account-creation";
import { LoomOverlayTemplate } from "@/components/signup/layouts";
import { useFeatureExposed } from "@/utils/feature-exposed";
import { useIsMobile } from "@/utils/useIsMobile";

import {
    InputSubmitButton,
    Headings,
    GetStartedText,
    FreeForTenUsersText
} from "../../components";

export const LoggedOutLoom = () => {
    const isMobile = useIsMobile(800);

    useFeatureExposed("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [!isMobile],
        metadata: {
            userType: "logged-out"
        }
    });

    return (
        <LoomOverlayTemplate size="sm">
            <Headings
                main={<GetStartedText productName="Loom" />}
                sub={<FreeForTenUsersText />}
            />
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </LoomOverlayTemplate>
    );
};
